const doc = [({"zh_cn":({"adminLabelCompanyInvoice":({"createdDate":"创建日期", "price":"价钱", "uniqueId":"发票号码。"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;